import React from 'react';

const AllShortcut = () => {
    return (
        <div className='text-center text-2xl font-bold'>
            Welcome to Admin Dashboard
        </div>
    );
};

export default AllShortcut;